export default "__VITE_ASSET__e32f1c88__"